<template>

  <DashboardLayout :menu-items="storeDashboardMenu">

    <div class="text-dashboard p-0 w-100 h-auto">
      <m-update-site-message-1/>
      <router-view name="dashboard"/>
    </div>

  </DashboardLayout>
</template>

<script>
import {mapActions} from 'vuex'
import DashboardLayout from '@/plugin/components/dashboard/Layout'
import {storeDashboardMenu} from '@/plugin/routes/DashboardRoutes'
import WidgetWallet from "@/plugin/components/dashboard/Wallet/WidgetWallet";
import DashboardMobileProfile from "../../../components/dashboard/DashboardMobileProfile";

export default {
  name: "StoreDashboardTemplate",
  components: {DashboardLayout, WidgetWallet, DashboardMobileProfile},
  data() {
    return {
      storeDashboardMenu
    }
  },
  methods: {
    ...mapActions({
      logout: "Authentication/logout"
    })
  }

};
</script>

<style>
.b-toaster {
  z-index: 9999999 !important;
}
</style>


<style scoped>
.text-dashboard {
  width: 100%;
  max-width: 100%;
  height: auto;
  background: #fff;
  margin: 0;
  border-radius: 0;
  padding: 0;
}

.inventory {
  font-size: 80%;
}

.my-dashboard {
  width: 100%;
  height: 70px;
  background: white;
  border-radius: 5px;

}

.profile-fixed {
  width: 50px;
  height: 50px;
  margin-right: 50px;
  margin-top: 12px;
}

.text-dashboard {
  width: 100%;
  max-width: 100%;
  height: auto;
  background: #fff;
  margin: 0;
  border-radius: 0;
}

#lblCartCount {
  font-size: 12px;
  background: #ff0000;
  color: #fff;
  padding: 0 5px;
  vertical-align: top;
  margin-left: -10px;
  margin-top: 0px;
}

.bell-big {
  width: 30px;
  height: 20px;
}

.profile-image {
  height: 150px;
  width: 150px;
  object-fit: contain;
}
</style>